export const COMMENT_VOTES = ".js-comment-votes"
export const COMMENT_VOTES_FORM_UPVOTE = ".js-comment-votes-form-upvote"
export const COMMENT_VOTES_FORM_DOWNVOTE = ".js-comment-votes-form-downvote"
export const COMMENT_VOTES_UPVOTES = ".js-comment-votes-upvotes"
export const COMMENT_VOTES_DOWNVOTES = ".js-comment-votes-downvotes"
export const COMMENT_VOTES_BUTTON_UPVOTE = ".js-comment-votes-upvote-submit"
export const COMMENT_VOTES_BUTTON_DOWNVOTE = ".js-comment-votes-downvote-submit"
export const COMMENT_VOTES_BUTTON_ACTIVE = "comment-votes__button--is-active"

export const SERVER_FORM_ERROR = "base"
